/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable-next-line no-unused-vars */
import { Route, Routes } from 'react-router-dom';

import LandingPage from 'pages/LandingPage';
import ServicePage from 'pages/ServicePage';
import NotFoundPage from 'pages/NotFoundPage';
import AboutUsPage from 'pages/AboutUsPage';
import GalleryPage from 'pages/GalleryPage';
import { ServiceDetailPage } from 'pages/ServiceDetailPage';
import { DiscussProjectPage } from 'pages/DiscussProjectPage';

import './assets/css/styles.css';

function App() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<LandingPage />} />
        <Route path="/service" element={<ServicePage />} />
        <Route exact path="/service/:id" element={<ServiceDetailPage />} />
        <Route exact path="/about" element={<AboutUsPage />} />
        <Route exact path="/gallery" element={<GalleryPage />} />
        <Route exact path="/discuss-project" element={<DiscussProjectPage />} />
        <Route path="**" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;
